import React, { useEffect, useState } from 'react';
import SVGFactory, { SVGName } from 'widgets/STW/components/svgFactory';
import { IDRTemplate } from '..';
import CopyIcon from '../../../icons/copyIcon';
import { decodeTextHelper } from '../../utility';
import { WIDGET_NAME } from '@bikdotai/bik-models/dm';
import { ComponentStyleMap } from '../../../utilities/styleUtils';
import { LanguageUtils } from '../../../utilities/languageUtilities';

const CouponDetails = (props: IDRTemplate) => {
  const languageUtilities = new LanguageUtils();
  const { discountCodeDetails, preview, isMobile, templateName } = props;
  const { discountCodeTitle, discountCodeDescription } = discountCodeDetails;
  const multiLingualData =
    props?.widgetCustomisation?.multiLingualConfigurations?.[
      props.widgetLanguage
    ];
  const [btnText, setBtnText] = useState<string>(
    multiLingualData?.postPlayScreenButtonText ??
      props.widgetCustomisation.postPlayScreenButtonText ??
      discountCodeTitle,
  );
  const [currentStyle, setCurrentStyle] = useState<any>(null);

  useEffect(() => {
    setBtnText(
      multiLingualData?.postPlayScreenButtonText ??
        props.widgetCustomisation.postPlayScreenButtonText,
    );
  }, [
    multiLingualData?.postPlayScreenButtonText,
    props.widgetCustomisation.postPlayScreenButtonText,
  ]);

  const onCopyHandle = () => {
    const cb = navigator.clipboard;
    cb.writeText(discountCodeDetails.discountCodeTitle).then(() => {
      setBtnText(languageUtilities.getCopiedMessage(props.widgetLanguage));
    });
  };

  const onRedirectionHandle = () => {
    window.open(
      props.widgetCustomisation.postPlayScreenButtonRedirection,
      '_blank',
    );
  };

  useEffect(() => {
    if (preview && isMobile) {
      ComponentStyleMap[templateName]?.thankyouPreviewMobile.then(
        async style => {
          setCurrentStyle((await style()).default);
        },
      );
    } else if (preview && !isMobile) {
      ComponentStyleMap[templateName]?.thankyouPreviewDesktop.then(
        async style => {
          setCurrentStyle((await style()).default);
        },
      );
    } else {
      ComponentStyleMap[templateName]?.globalStyle.then(async style => {
        setCurrentStyle((await style()).default);
      });
    }
  }, [preview, isMobile]);

  if (!currentStyle) {
    return <></>;
  }

  let postPlayScreenTitleSize: string;
  let postPlayScreenSubTitleSize: string;

  if (preview) {
    postPlayScreenTitleSize = isMobile ? '12px' : '11px';
    postPlayScreenSubTitleSize = isMobile ? '11px' : '9px';
  } else {
    postPlayScreenTitleSize = isMobile ? '20px' : `26px`;
    postPlayScreenSubTitleSize = isMobile ? '14px' : `16px`;
  }

  return (
    <>
      {templateName === WIDGET_NAME.DIRECT_REWARD && (
        <div
          className={currentStyle.bikDRContentWrapper}
          id={`bik-${props.id}-coupon-screen`}
        >
          <div className={currentStyle.bikDRTitleWrapper}>
            <div
              className={currentStyle.bikDRTitle}
              style={{
                fontSize: postPlayScreenTitleSize,
                fontFamily: props.widgetCustomisation.fontFamily?.name,
                color: props.widgetCustomisation?.fontColour,
              }}
              dangerouslySetInnerHTML={{
                __html: decodeTextHelper(
                  multiLingualData?.postPlayScreenTitle ??
                    props.widgetCustomisation.postPlayScreenTitle,
                ),
              }}
            />
            <div
              className={currentStyle.bikDRSubTitle}
              style={{
                fontSize: postPlayScreenSubTitleSize,
                fontFamily: props.widgetCustomisation.fontFamily?.name,
                color: props.widgetCustomisation?.fontColour,
              }}
              dangerouslySetInnerHTML={{
                __html: decodeTextHelper(
                  multiLingualData?.postPlayScreenSubTitle ??
                    props.widgetCustomisation.postPlayScreenSubTitle,
                ),
              }}
            />
          </div>
          <div className={currentStyle.bikDRDiscountCodeDetailsMain}>
            <div
              style={{
                backgroundColor:
                  props.widgetCustomisation.postPlayScreenCouponBgColour,
                borderColor:
                  props.widgetCustomisation.postPlayScreenCouponBorderColour,
                fontFamily: props.widgetCustomisation.fontFamily?.name,
              }}
              className={currentStyle.bikDRDiscountCodeDetailsContainer}
            >
              <h4>{discountCodeTitle}</h4>
              <p>{discountCodeDescription}</p>
            </div>
            <button
              style={{
                backgroundColor:
                  props.widgetCustomisation.postPlayScreenButtonColour,
                color: props.widgetCustomisation.postPlayScreenButtonTextColour,
                fontFamily: props.widgetCustomisation.fontFamily?.name,
              }}
              onClick={
                props.widgetCustomisation.postPlayScreenButtonRedirection
                  ? onRedirectionHandle
                  : onCopyHandle
              }
            >
              <div
                style={{
                  marginRight: 7,
                  color:
                    props.widgetCustomisation.postPlayScreenButtonTextColour,
                }}
              >
                {btnText}
              </div>
              {!props.widgetCustomisation.isRedirectionButtonEnabled && (
                <CopyIcon
                  colour={
                    props.widgetCustomisation.postPlayScreenButtonTextColour
                  }
                />
              )}
            </button>
          </div>
          {!props.widgetCustomisation.hidePoweredBy && (
            <p className={currentStyle.poweredBy}>
              <a
                href="https://bik.ai/?utm_campaign=Direct_Reward&utm_medium=Widgets&utm_source=Powered_by_bik"
                target="_blank"
                rel="noreferrer"
              >
                {languageUtilities.getPoweredByMessage(props.widgetLanguage)}
              </a>
              <SVGFactory name={SVGName.BIK} />
            </p>
          )}
        </div>
      )}
      {templateName === WIDGET_NAME.LEAD_GENERATOR && (
        <div
          className={currentStyle.bikDRContentWrapper}
          id={`bik-${props.id}-coupon-screen`}
        >
          <div>
            {props.widgetCustomisation.postPlayScreenTitleIcon && (
              <div className={currentStyle.leadGenPostPlayIconWrapper}>
                <img
                  src={props.widgetCustomisation.postPlayScreenTitleIcon}
                  className={currentStyle.leadGenPostPlayIcon}
                />
              </div>
            )}
            <div className={currentStyle.bikDRTitleWrapper}>
              <div
                className={currentStyle.bikDRTitle}
                style={{
                  fontSize: postPlayScreenTitleSize,
                  fontFamily: props.widgetCustomisation.fontFamily?.name,
                  color: props.widgetCustomisation?.fontColour,
                }}
                dangerouslySetInnerHTML={{
                  __html: decodeTextHelper(
                    multiLingualData?.postPlayScreenTitle ??
                      props.widgetCustomisation.postPlayScreenTitle,
                  ),
                }}
              />
              <div
                className={currentStyle.bikDRSubTitle}
                style={{
                  fontSize: postPlayScreenSubTitleSize,
                  fontFamily: props.widgetCustomisation.fontFamily?.name,
                  color: props.widgetCustomisation?.fontColour,
                }}
                dangerouslySetInnerHTML={{
                  __html: decodeTextHelper(
                    multiLingualData?.postPlayScreenSubTitle ??
                      props.widgetCustomisation.postPlayScreenSubTitle,
                  ),
                }}
              />
            </div>
          </div>
          {props.widgetCustomisation.isRedirectionButtonEnabled && (
            <div className={currentStyle.bikDRDiscountCodeDetailsMain}>
              <button
                style={{
                  backgroundColor:
                    props.widgetCustomisation.postPlayScreenButtonColour,
                  color:
                    props.widgetCustomisation.postPlayScreenButtonTextColour,
                }}
                onClick={onRedirectionHandle}
              >
                <div
                  style={{
                    marginRight: 7,
                    fontFamily: props.widgetCustomisation.fontFamily?.name,
                    color:
                      props.widgetCustomisation.postPlayScreenButtonTextColour,
                  }}
                >
                  {multiLingualData?.postPlayScreenButtonText ??
                    props.widgetCustomisation.postPlayScreenButtonText}
                </div>
              </button>
            </div>
          )}
          <p className={currentStyle.poweredBy}>
            <a
              href="https://bik.ai/?utm_campaign=Direct_Reward&utm_medium=Widgets&utm_source=Powered_by_bik"
              target="_blank"
              rel="noreferrer"
            >
              {languageUtilities.getPoweredByMessage(props.widgetLanguage)}
            </a>
            <SVGFactory name={SVGName.BIK} />
          </p>
        </div>
      )}
    </>
  );
};
export default CouponDetails;
